import "core-js/modules/es6.regexp.to-string";
import CryptoJS from "crypto-js";
import md5 from 'md5';

/**
 * AES 加密   和java后台一样
 * @param {*} str 
 * @returns 
 */
export function encryptAES(str) {
  //346da78be39d3978
  var key = md5("yzx").substring(0, 16); //协议要求传一个16位的随机串
  var raw = CryptoJS.enc.Utf8.parse(key);
  var src = CryptoJS.enc.Utf8.parse(str);
  var ciphertext = CryptoJS.AES.encrypt(src, raw, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
  return ciphertext;
}

/**
 * AES 解密  和java后台一样
 * @param {*} str 
 */
export function decryptAES(ciphertext) {
  //346da78be39d3978
  var key = md5("yzx").substring(0, 16); //协议要求传一个16位的随机串
  var raw = CryptoJS.enc.Utf8.parse(key);
  var bytes = CryptoJS.AES.decrypt(ciphertext, raw, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
}